import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Banner, Box, CloseButton } from '@zillow/constellation-10';

import { bannerBoxRecipe } from '../styles';

import { useAuth } from '../../AuthProvider';

export const PropertiesPageNotifications = () => {
  const router = useRouter();
  const { user } = useAuth();

  const [displayListingClaimCompleteBanner, setDisplayListingClaimCompleteBanner] = useState(false);

  useEffect(() => {
    if (router.query.itc === 'listing_claim_complete') {
      setDisplayListingClaimCompleteBanner(true);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  return (
    <div data-testid="PropertiesPageNotifications">
      {displayListingClaimCompleteBanner && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => setDisplayListingClaimCompleteBanner(false)}
          >
            Select a property below to view and manage its information
          </Banner>
        </Box>
      )}
    </div>
  );
};
